import { useMutation } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { apiV1Endpoint } from "../../../../api/v1";
import { ApiResponse } from "../../../../types/api-response";

type UpdateCustomFieldsRequest = {
  propertyId: string;
  payload: { financialDimensions: unknown };
};

const updateFinancialDimensionsRequest = async ({ propertyId, payload }: UpdateCustomFieldsRequest) => {
  const url = `${apiV1Endpoint}/property/financialdimensions/${propertyId}`;

  const response = await axios.patch<ApiResponse>(url, payload);
  return response.data.result;
};

type UseUpdateFinancialDimensionsOptions = {
  onSuccess?: () => void;
  onError?: (error: AxiosError<ApiResponse>) => void;
};

export const useUpdateFinancialDimensions = (options: UseUpdateFinancialDimensionsOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutateAsync, isPending } = useMutation({
    mutationFn: updateFinancialDimensionsRequest,
    onSuccess,
    onError,
  });

  return {
    updateFinancialDimensionsRequest: mutateAsync,
    isPendingUpdateFinancialDimensions: isPending,
  };
};
